import React from 'react';

// Quantiles every challenge requests (platform-wide today).
const VARIABLES = ['Q10', 'Q50', 'Q90'];
const VARIABLES_TITLE =
  'Submit three quantiles per timestamp: Q10, Q50 (median) and Q90 - your '
  + "forecast's lower bound, central estimate and upper bound.";
// Keep directory rows uniform: show at most this many horizon chips, then
// group the rest into a single overflow chip.
const MAX_VISIBLE = 2;

// Plain-language meaning of a horizon, used as the chip's hover tooltip.
const horizonMeaning = (h) => {
  if (h.challenge_type === 'intraday') {
    return 'Intraday: a rolling forecast covering the hours right after each '
      + 'gate closure.';
  }
  if (h.horizon_offset === 1) {
    return 'Day-ahead (D+1): a forecast for the whole next calendar day.';
  }
  return `Extended (D+${h.horizon_offset}): a forecast for a day `
    + `${h.horizon_offset} days ahead.`;
};

const chipTitle = (h) => `${horizonMeaning(h)} Gate closes ${h.cadence}.`;
const horizonText = (h) => `${h.label}${h.cadence ? ` · ${h.cadence}` : ''}`;

// Compact public badges of the paid horizons a market publishes, fed by the
// `program_summary` injected on the markets directory payload (derived live
// from the active challenge templates). Renders nothing when a market has no
// paid horizons yet (the caller shows its own fallback).
export default function ProgramBadges({ summary }) {
  const horizons = (summary && summary.horizons) || [];
  if (horizons.length === 0) return null;

  const visible = horizons.slice(0, MAX_VISIBLE);
  const overflow = horizons.slice(MAX_VISIBLE);

  return (
    <div
      data-testid="program-badges"
      className="mt-1 flex flex-wrap items-center gap-1.5"
    >
      {visible.map((h) => (
        <span
          key={h.label}
          title={chipTitle(h)}
          className="inline-flex cursor-help items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-semibold bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300"
        >
          {h.label}
          {h.cadence && (
            <span className="font-normal text-brand-600/70 dark:text-brand-300/70">
              · {h.cadence}
            </span>
          )}
        </span>
      ))}
      {overflow.length > 0 && (
        <span
          title={overflow.map((h) => `${horizonText(h)} - ${horizonMeaning(h)}`).join('\n')}
          className="inline-flex cursor-help items-center rounded px-1.5 py-0.5 text-[10px] font-semibold bg-slate-100 text-slate-600 dark:bg-gray-700 dark:text-gray-300"
        >
          +{overflow.length}
        </span>
      )}
      <span
        title={VARIABLES_TITLE}
        className="cursor-help text-[10px] text-slate-400 dark:text-gray-500"
      >
        {VARIABLES.join(' / ')}
      </span>
    </div>
  );
}
